import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  getClientMessage(error: Error): string {
    if (!navigator.onLine) {
      return 'No Internet Connection';
    }
    return error.message ? error.message : JSON.stringify(error);
  }

  getServerMessage(error: HttpErrorResponse): string {
    return error.message ? error.message : 'Please try again later.';
  }
}
